export type EphimeralMessage = {
  type: string
}

function makeKey(type: string) {
  return `rh:ep-${type}`
}

function store<T extends EphimeralMessage>(message: T) {
  localStorage.setItem(makeKey(message.type), JSON.stringify(message))
}

function retrieve<T extends EphimeralMessage>(type: T['type']): T | null {
  const raw = localStorage.getItem(makeKey(type))
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

function remove<T extends EphimeralMessage>(type: T['type']) {
  localStorage.removeItem(makeKey(type))
}

function consume<T extends EphimeralMessage>(type: T['type']): T | null {
  const message = retrieve(type)
  if (message) {
    remove(type)
  }
  return message
}

function update<T extends EphimeralMessage>(
  message: { type: T['type'] } & Partial<T>
) {
  const current = retrieve(message.type) ?? { type: message.type }
  const newMessage = { ...current, ...message }
  store(newMessage)
}

export const EphimeralService = {
  store,
  retrieve,
  remove,
  consume,
  update,
}
